/* eslint-disable prettier/prettier */
import { IconCircle, IconEdit, IconFile, IconHome, IconPeople, IconView } from './Icons';

export const Steepers = ({ step, form }) => {
  return (
    <div className="flex items-center">
      <div className="flex items-center relative"></div>

      <div className="flex items-center relative">
        <div
          className={`rounded-full h-12 w-12 py-3 flex items-center border-2 justify-center ${step === 1
            ? 'bg-red-100 border-red-500 border-2'
            : step > 1
              ? 'border-green-200 bg-green-100 border-2'
              : 'border-gray-300'
            }`}>
          <span
            className={`${step === 1 ? 'fill-red-500' : step > 1 ? 'fill-green-500 ' : 'fill-gray-300'
              }`}>
            <IconEdit />
          </span>
        </div>
        <div
          className={`absolute top-0 -mr-10 text-center hide-text mt-16 w-32 text-xs font-medium uppercase ${step === 1 ? 'text-red-500' : step > 1 ? 'text-slate-400 ' : 'text-gray-300'
            }`}>
          الشروط والأحكام
        </div>
      </div>
      <div
        className={`flex-auto border-t-2  ${step === 1 ? 'border-red-500' : 'border-gray-300'
          }`}>
      </div>
      <div className="flex items-center relative">
        <div
          className={`rounded-full h-12 w-12 py-3 border-2 flex items-center justify-center ${step === 2
            ? 'bg-red-100 border-red-200'
            : step > 2
              ? 'border-green-200 bg-green-100 border-2'
              : 'border-gray-300'
            }`}>
          <span
            className={`${step === 2 ? 'fill-red-500' : step > 2 ? 'fill-green-500 ' : 'fill-gray-300'
              }`}>
            <IconHome />
          </span>
        </div>
        <div
          className={`absolute top-0 -mr-10 text-center hide-text mt-16 w-32 text-xs font-medium uppercase ${step === 2 ? 'text-red-500' : step > 1 ? 'text-slate-400' : 'text-gray-300'
            }`}>
          المناطق و الكابينات
        </div>
      </div>
      
      <div
        className={`flex-auto border-t-2  ${step === 3 ? 'border-red-200' : 'border-gray-300'
          }`}>
      </div>
      <div className="flex items-center text-gray-500 relative">
        <div
          className={`rounded-full h-12 w-12 py-3 border-2 flex items-center justify-center ${step === 3
            ? 'bg-red-100 border-red-200'
            : step > 3
              ? 'border-green-200 bg-green-100 border-2'
              : 'border-gray-300'
            }`}>
          <span
            className={`${step === 3 ? 'fill-red-500' : step > 3 ? 'fill-green-500 ' : 'fill-gray-300'
              }`}>
            <IconView />
          </span>
        </div>
        <div
          className={`absolute top-0 -mr-10 text-center hide-text mt-16 w-32 text-xs font-medium uppercase ${step === 3 ? 'text-red-500' : step > 3 ? 'text-slate-400' : 'text-gray-300'
            }`}>
          مراجعة المعلومات
        </div>
      </div>
    </div>
  );
};
